<template>
  <div>
 
    <div  id="container" style="height:600px;"></div>
		<DxPopup
      :visible.sync="paused "
      :drag-enabled="true"
	  :shading="false"
      :close-on-outside-click="false"
      :show-title="true"
      :width="300"
      :height="50"
      title="Paused: Space Toggles"
    >
	</DxPopup>
	<DxPopup
      :visible.sync="loadingModel"
      :drag-enabled="true"
	  :shading="false"
      :close-on-outside-click="false"
      :show-title="true"
      :width="300"
      :height="50"
      title="Loading Model..."
	 
    >   
    </DxPopup>
		<DxPopup
      :visible.sync="popupVisible"
      :drag-enabled="false"
      :close-on-outside-click="true"
      :show-title="true"
      :width="300"
      :height="300"
      title="Underwater Demo"
    >
	Drop GLTF Files on Background<br><br>
	
		W:Forward<br>
		A:left<br>
		S:Back<br>
		D:Right<br>
<br>
		R:UP<br>
		F:Down<br>
<br>
		Space:Play/Pause<br>
      
      
    </DxPopup>
	
  </div>
</template>

<script>

var paused=false
var loadingModel=false
export default {
   	components: {
		   DxPopup,
  },

		data: () => ({
		popupVisible: true,
			paused:false,
			loadingModel:false,
			
		}),
		
		mounted(){
			init();
			animate();
			requestAnimationFrame( this.checkStatus );
			document.addEventListener('keyup', this.keyUp);
		},
		computed:{
			debug(){
      			return this.$store.getters.getDebug
    		}
		},
		methods:{
			checkStatus(){
				
				this.loadingModel=loadingModel
				requestAnimationFrame( this.checkStatus );
			},
		keyUp(e){
				switch(e.key){
					case " ":
						console.log("pause")
						this.paused=!this.paused
						paused=this.paused
						break
				
				}
			}
	   
		},
		watch:{
			debug(val){
				if(val){
					container.appendChild( stats.dom );
				}else{
					container.removeChild( stats.dom );
				}
			},
		},
		beforeDestroy(){
			
			if ( gui ) gui.destroy();
		}
	};



			import * as THREE from 'three';

			import Stats from 'three/examples/jsm/libs/stats.module.js';
			import * as dat from 'dat.gui';
			import { DxPopup } from 'devextreme-vue/popup';
			import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js';
			import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass.js';
			import { ShaderPass } from 'three/examples/jsm/postprocessing/ShaderPass.js';
			import { BloomPass } from 'three/examples/jsm/postprocessing/BloomPass.js';
			
			import { UnrealBloomPass } from 'three/examples/jsm/postprocessing/UnrealBloomPass.js';
			import { FilmPass } from 'three/examples/jsm/postprocessing/FilmPass.js';
			import { RGBShiftShader } from 'three/examples/jsm/shaders/RGBShiftShader.js';
			import { DotScreenShader } from 'three/examples/jsm/shaders/DotScreenShader.js';
			import { DotScreenPass } from 'three/examples/jsm/postprocessing/DotScreenPass.js';
			import { SobelOperatorShader } from 'three/examples/jsm/shaders/SobelOperatorShader.js';
			
			import { MaskPass, ClearMaskPass } from 'three/examples/jsm/postprocessing/MaskPass.js';
			import { TexturePass } from 'three/examples/jsm/postprocessing/TexturePass.js';

			import { BleachBypassShader } from 'three/examples/jsm/shaders/BleachBypassShader.js';
			import { ColorifyShader } from 'three/examples/jsm/shaders/ColorifyShader.js';
			import { HorizontalBlurShader } from 'three/examples/jsm/shaders/HorizontalBlurShader.js';
			import { VerticalBlurShader } from 'three/examples/jsm/shaders/VerticalBlurShader.js';
			import { SepiaShader } from 'three/examples/jsm/shaders/SepiaShader.js';
			import { VignetteShader } from 'three/examples/jsm/shaders/VignetteShader.js';
			import { GammaCorrectionShader } from 'three/examples/jsm/shaders/GammaCorrectionShader.js';
			
			import * as Nodes from 'three/examples/jsm/nodes/Nodes.js';
			import {ImprovedNoise} from 'three/examples/jsm/math/ImprovedNoise.js';
			import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
			import { FirstPersonControls } from 'three/examples/jsm/controls/FirstPersonControls.js';
			import { Floaties } from '../assets/scripts/objects/Floaties'


		
			
			var camera, scene, renderer, composer;
			var object, light,Alight;
			var spotLight,floaties
			var bloomParams
			var bloomPass
			var container
			var controls
			var params
			var clock = new THREE.Clock();
			var stats,gui
			var effect,effect2,effect3,effect4
			var loadedModel
			var lightRays
			var sceneModels={}
			//
			var mesh,texture, worldWidth = 1024, worldDepth = 1024,
		  	worldHalfWidth = worldWidth / 2, worldHalfDepth = worldDepth / 2;
			//init();
			//animate();

			function init() {
				console.log("INIT")
				container = document.getElementById( 'container' );
				renderer = new THREE.WebGLRenderer();
				renderer.setPixelRatio( window.devicePixelRatio );
				renderer.setSize( window.innerWidth, window.innerHeight );
				container.appendChild( renderer.domElement );
				//document.body.appendChild( renderer.domElement );

				//

				camera = new THREE.PerspectiveCamera( 70, window.innerWidth / window.innerHeight, 1, 9000 );
				camera.position.x = 1400;
				camera.position.z = 400;
				camera.position.y = 400;

				scene = new THREE.Scene();
				
				object = new THREE.Object3D();
				scene.add( object );
				object.position.x = 1400;
				object.position.z = 400;
				object.position.y = 400;


	 
 


				//cone
				var texture = new THREE.TextureLoader().load(require( '../assets/images/rays2.png' ));
				texture.wrapS = THREE.RepeatWrapping;
				texture.wrapT = THREE.RepeatWrapping;
				texture.repeat.set( 6, 1 );
		
				var geometry = new THREE.CylinderGeometry( 800,3200, 6500, 32,2,true );
				//var material = new THREE.MeshBasicMaterial( {color: 0xffff00,opacity: 0.5,visible: true} );
				var material = new THREE.MeshPhysicalMaterial( {
					color: 0xffffff,
					metalness: 1,
					roughness: 1,
					side : THREE.DoubleSide,
					//alphaTest: 1,
					flatShading:false,
					emissive:0xffffff,
					emissiveIntensity:10,
					depthWrite: false,
					transparency: .9, // use material.transparency for glass materials
					opacity: 1,                        // set material.opacity to 1 when material.transparency is non-zero
					transparent: true,
					//map: texture,
					alphaMap: texture 
				} );
				// MATERIAL
						//var // MATERIAL

lightRays = new THREE.Mesh( geometry, material );
lightRays.position.set(0,0,0)
scene.add( lightRays );
				controls = new FirstPersonControls( camera, renderer.domElement );
				controls.movementSpeed = 100;
				controls.lookSpeed = 0.05;

				var geometry = new THREE.SphereBufferGeometry( 1, 4, 4 );
				var materialX = new THREE.MeshPhongMaterial( { color: 0xffffff, flatShading: true } );
				var material = new THREE.MeshBasicMaterial( {

						color: 0x00e0ff,
						wireframe: true

					} );
				for ( var i = 0; i < 100; i ++ ) {

					var mesh = new THREE.Mesh( geometry, material );
					mesh.position.set( Math.random() - 0.5, Math.random() - 0.5, Math.random() - 0.5 ).normalize();
					mesh.position.multiplyScalar( Math.random() * 400 );
					mesh.rotation.set( Math.random() * 2, Math.random() * 2, Math.random() * 2 );
					mesh.scale.x = mesh.scale.y = mesh.scale.z = Math.random() * 50;
					object.add( mesh );

				}
				Alight = new THREE.AmbientLight( 0x222222 ); // soft white light
        		scene.add( Alight );
                scene.fog = new THREE.FogExp2( 0x226666, 0.0005);
			
				light = new THREE.DirectionalLight( 0xffffff );
				light.position.set( 1, 1, 1 );
				scene.add( light );
				// SpotLight       
				spotLight = new THREE.SpotLight( 0xffffff);
				spotLight.intensity=1;
				spotLight.angle = Math.PI / 6;
				spotLight.penumbra =.5;
				spotLight.distance = 1000;
				scene.add( spotLight );
				camera.add( spotLight.target );
				spotLight.target.position.set( 0, 0, -1 );
				// FLoaties
				floaties = new Floaties(3,.2)
				floaties.setFall(0)
				console.log("FLOATIES",floaties)
				//processing
				bloomParams = {
				exposure: 1,
				bloomStrength: 0,//4.5,
				bloomThreshold: 0,
				bloomRadius: 0
			}
				scene.add(floaties.particles);

				//Stats
		stats = new Stats();
		//container.appendChild( stats.dom );
		// GUI
		createGUI()
			

				composer = new EffectComposer( renderer );
				composer.addPass( new RenderPass( scene, camera ) );

			
				const loader = new GLTFLoader();
				console.log("DROP")
				document.addEventListener( 'dragover', function ( event ) {

					event.preventDefault();
					event.dataTransfer.dropEffect = 'copy';

				}, false );
				 document.body.addEventListener("drop", async e => {
					console.log("DROP",e)
					loadingModel=true
					//remove old object
					scene.remove( object );
					event.preventDefault();
					let file = null;
					if (e.dataTransfer.items) {
						file = e.dataTransfer.items[0].getAsFile();
					} else {
						file = e.dataTransfer.files[0];
					}
					console.log("file.name = " + file.name);
					const gltf = await new Promise((resolve, reject) => {
						const reader = new FileReader();
						reader.onload = e => {
							loader.parse(e.target.result, "/", resolve, reject);
						};
						reader.readAsArrayBuffer(file);
					});
					console.log("parsed gltf", gltf);
					loadedModel=gltf
					gltf.scene.traverse( child => {
					if ( child.material ) {
						//child.material.wireframe=true
						
						getModelData(child)
						child.material.metalness = 0;
					}
					
				} );
					loadingModel=false
					console.log(sceneModels)
					
					scene.add(gltf.scene);
					
				}, false );

			
			//
			var effectSobel = new ShaderPass( SobelOperatorShader );
				effectSobel.uniforms[ 'resolution' ].value.x = window.innerWidth * window.devicePixelRatio;
				effectSobel.uniforms[ 'resolution' ].value.y = window.innerHeight * window.devicePixelRatio;
				effectSobel.enabled = false;
			composer.addPass( effectSobel );

			bloomPass = new UnrealBloomPass( new THREE.Vector2( window.innerWidth, window.innerHeight ), 1.5, 0.4, 0.85 );
			bloomPass.threshold = bloomParams.bloomThreshold;
			bloomPass.strength = bloomParams.bloomStrength;
			bloomPass.radius = bloomParams.bloomRadius;
			composer.addPass( bloomPass );

			effect = new ShaderPass( VergilWaterShader );
			effect = new ShaderPass( VergilWaterShader );
            effect.uniforms['centerX'].value = 0.8;
            effect.uniforms['centerY'].value = 0.8;
            composer.addPass( effect );
            effect2 = new ShaderPass( VergilWaterShader );
            effect2.uniforms['centerX'].value = 0.2;
            effect2.uniforms['centerY'].value = 0.2;
            composer.addPass( effect2 );
            effect3 = new ShaderPass( VergilWaterShader );
            effect3.uniforms['centerX'].value = 0.2;
            effect3.uniforms['centerY'].value = 0.8;
            composer.addPass( effect3 );
            effect4 = new ShaderPass( VergilWaterShader );
            effect4.uniforms['centerX'].value = 0.8;
            effect4.uniforms['centerY'].value = 0.2;
            effect4.renderToScreen = true;
            composer.addPass( effect4 );
			

			window.addEventListener( 'resize', onWindowResize, false );

			}
			function setRays(val){
				if(val){
					scene.add(lightRays)
				}else{
					scene.remove(lightRays)
				}
			}
			function setWireFrame(val){
				if(loadedModel){
					loadedModel.scene.traverse( child => {
					if ( child.material ) {
						child.material.wireframe=val
						
					}
				})
				}
			}	
			function onWindowResize() {

				camera.aspect = window.innerWidth / window.innerHeight;
				camera.updateProjectionMatrix();

				renderer.setSize( window.innerWidth, window.innerHeight );
				composer.setSize( window.innerWidth, window.innerHeight );

			}
		
			function getModelData(child){
				let name=child.name
				let pos=child.position
				let instance=name.split("_")
				
				if(instance.length>1){
					let id=instance.pop()
					
					addToSceneModels(instance.join("_"),{name:name,pos:pos})

				}else{
					addToSceneModels("other",{name:name,pos:pos})
				}

			}
			function addToSceneModels(type,model){
				if(!sceneModels[type]){
					sceneModels[type]=[]
				}
				sceneModels[type].push(model)
			}
			function animate() {

				requestAnimationFrame( animate );
				//console.log("animate")
				

				//composer.render();
				
					update()
				
				
				//renderer.render( scene, camera );

			}
			function update() {
				if(params.waterDistort){
				effect.uniforms['time'].value += Math.random();
				effect2.uniforms['time'].value += Math.random();
				effect3.uniforms['time'].value += Math.random();
				effect4.uniforms['time'].value += Math.random();
				}
				var time = performance.now() * 0.001;
				var deltaTime=clock.getDelta()
				floaties.update(time)
				floaties.particles.position.y=camera.position.y;
				spotLight.position.copy( camera.position );
				lightRays.position.copy( camera.position );
				//lightRays.position.set(camera.position.x,0,camera.position.z)
				if(!paused){
					object.rotation.x += 0.005;
				object.rotation.y += 0.01;
				 controls.update( deltaTime );
				}
				stats.begin();

	// monitored code goes here

	stats.end();
				composer.render();
				
			}
				function createGUI(){
		// GUI
		console.log(gui)
		if ( gui ) {
			 try{
				gui.destroy();
			}
			catch(err){
			}	
		}
		
	class FogGUIHelper {
    		constructor(fog, backgroundColor) {
      			this.fog = fog;
      			this.backgroundColor = backgroundColor;
    		}
			get near() {
				return this.fog.near;
			}
			set near(v) {
				this.fog.near = v;
				this.fog.far = Math.max(this.fog.far, v);
			}
			get far() {
				return this.fog.far
			}
			set far(v) {
				this.fog.far = v;
				this.fog.near = Math.min(this.fog.near, v);
			}
			get color() {
				return `#${this.fog.color.getHexString()}`;
			}
			set color(hexString) {
				this.fog.color.set(hexString);
				this.backgroundColor.set(hexString);
			}
		}						
  	
		const color = '#226666';
		const near = 0;
		const far = 50000;
		scene.fog = new THREE.Fog(color, 0, 2000);
		scene.background = new THREE.Color(color);
		const fogGUIHelper = new FogGUIHelper(scene.fog, scene.background);
   
  
		gui = new dat.GUI();
		var fogOptions={
			color:scene.fog.color
		}
		params={
			showWireFrame:false,
			waterDistort:false,
			showRays:true
		}
		var folder = gui.addFolder( 'Global Light' );
		folder.add( Alight, 'intensity', 0, 4, .1 ).name( 'Ambient Light' );
		folder.add( light, 'intensity', 0, 4, .1).name( 'Direction Light' );
		var folderSL = gui.addFolder( 'Divers Spotlight' );
		folderSL.add( spotLight, 'intensity', 0, 10, 1 ).name( 'Intensity' );
		folderSL.add( spotLight, 'angle', 0, 1, .1 ).name( 'Angle' );
		folderSL.add( spotLight, 'penumbra', 0, 1, .1 ).name( 'Penumbra' );
		folderSL.add( spotLight, 'distance', 0, 5000, 10 ).name( 'Range' );
		var folderFog = gui.addFolder( 'Fog' );
		folderFog.add(fogGUIHelper, 'near', near, far).listen();
   		folderFog.add(fogGUIHelper, 'far', near, far).listen();
		folderFog.addColor(fogGUIHelper, 'color');
		var folderProcessing = gui.addFolder( 'Effects' );
		
		folderProcessing.add( params, 'waterDistort' ).name("Distort")
		folderProcessing.add( params, 'showRays' ).onChange( function ( value ) {
			setRays(value)
		} );
		folderProcessing.add( params, 'showWireFrame' ).onChange( function ( value ) {
			setWireFrame(value)
		} );
		folderProcessing.add( bloomParams, 'exposure', 0.1, 2 ).onChange( function ( value ) {
			renderer.toneMappingExposure = Math.pow( value, 4.0 );
		} );
		folderProcessing.add( bloomParams, 'bloomThreshold', 0.0, 1.0 ).onChange( function ( value ) {
			bloomPass.threshold = Number( value );
		} );
		folderProcessing.add( bloomParams, 'bloomStrength', 0.0, 3.0 ).onChange( function ( value ) {
			bloomPass.strength = Number( value );
		} );
		folderProcessing.add( bloomParams, 'bloomRadius', 0.0, 5.0 ).step( 0.01 ).onChange( function ( value ) {
			bloomPass.radius = Number( value );
		} );


			//folder.open();
		//
	}
	//
const VergilWaterShader = {

	uniforms: {
		"tDiffuse": { type: "t", value: null },
		"time":     { type: "f", value: 0.0},
		"distort_speed": {type: "f", value: 0.0005},
		"distortion":   { type: "f", value: 0.08 },
		//"distort_speed": {type: "f", value: 0.0005},
		//"distortion":   { type: "f", value: 0.04 },
		"centerX": {type: "f", value: 0.5},
		"centerY": {type: "f", value: 0.5},
	},

	vertexShader: [

	"varying vec2 vUv;",
	"void main() {",
		"vUv = uv;",
		"gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );",

	"}"

	].join("\n"),

	fragmentShader: [

	"uniform sampler2D tDiffuse;",
	"uniform float time;",
	"uniform float distort_speed;",
	"uniform float distortion;",
	"uniform float centerX;",
	"uniform float centerY;",
	"varying vec2 vUv;",

	"void main() {",
		"vec2 p = vUv;",
		"vec2 center_coord;",
		"float distance_to_center;",
		"float projected_distance_to_center;",
		"float distort_degree;",

		"center_coord.x = p.x - centerX;",
		"center_coord.y = p.y - centerY;",
		"distance_to_center = sqrt(center_coord.x * center_coord.x + center_coord.y * center_coord.y);",
		"distort_degree = abs( mod(distort_speed* time, distortion) - (distortion / 2.0)) + 1.0;",
		"projected_distance_to_center = pow(1.0, distort_degree - 1.0) * pow(distance_to_center/1.0, distort_degree);",
		"p.x = projected_distance_to_center * center_coord.x/ distance_to_center + centerX;",
		"p.y = projected_distance_to_center * center_coord.y/ distance_to_center + centerY;",
		"vec4 color = texture2D(tDiffuse, p);",
		"gl_FragColor = color;",

	"}"


	].join("\n")

};
		</script>


<style scoped>

</style>